module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('form', {
    staticClass: "form-horizontal pt10px"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-2 control-label"
  }, [_vm._v("指令参数")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicles),
      expression: "vehicles"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "readonly": "readonly"
    },
    domProps: {
      "value": (_vm.vehicles)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.vehicles = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.vehicles),
      expression: "vehicles"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.vehicles = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("车型列表")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("标准OBD")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v("丰田")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "3"
    }
  }, [_vm._v("日产")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "4"
    }
  }, [_vm._v("本田，宝马")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "5"
    }
  }, [_vm._v("大众")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "6"
    }
  }, [_vm._v("通用")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "7"
    }
  }, [_vm._v("福特")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "8"
    }
  }, [_vm._v("标致")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "9"
    }
  }, [_vm._v("雪铁龙")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("奔驰")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "11"
    }
  }, [_vm._v("斯巴鲁")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "12"
    }
  }, [_vm._v("起亚")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "13"
    }
  }, [_vm._v("现代")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "14"
    }
  }, [_vm._v("沃尔沃")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "15"
    }
  }, [_vm._v("雷诺")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "18"
    }
  }, [_vm._v("名爵")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "19"
    }
  }, [_vm._v("长安")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "20"
    }
  }, [_vm._v("铃木")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "21"
    }
  }, [_vm._v("帝豪")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "22"
    }
  }, [_vm._v("传祺")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "23"
    }
  }, [_vm._v("长城")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "24"
    }
  }, [_vm._v("荣威")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("九龙")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "26"
    }
  }, [_vm._v("欧宝")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "27"
    }
  }, [_vm._v("海马")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "28"
    }
  }, [_vm._v("北汽")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "29"
    }
  }, [_vm._v("中兴")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "30"
    }
  }, [_vm._v("中泰")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "31"
    }
  }, [_vm._v("路虎")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "32"
    }
  }, [_vm._v("宝马")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "33"
    }
  }, [_vm._v("奔腾")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "34"
    }
  }, [_vm._v("哈弗")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "35"
    }
  }, [_vm._v("中华")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "36"
    }
  }, [_vm._v("五十铃")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "37"
    }
  }, [_vm._v("比亚迪")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "38"
    }
  }, [_vm._v("吉利")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "39"
    }
  }, [_vm._v("风行")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "40"
    }
  }, [_vm._v("SMART")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "41"
    }
  }, [_vm._v("华晨")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "42"
    }
  }, [_vm._v("风神")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "43"
    }
  }, [_vm._v("大宇")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "44"
    }
  }, [_vm._v("双龙")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "45"
    }
  }, [_vm._v("华泰")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "46"
    }
  }, [_vm._v("捷豹")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "47"
    }
  }, [_vm._v("江淮")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "48"
    }
  }, [_vm._v("陆风")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "49"
    }
  }, [_vm._v("大发")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("萨博")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "51"
    }
  }, [_vm._v("马自达")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "52"
    }
  }, [_vm._v("三菱")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "53"
    }
  }, [_vm._v("罗孚")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "54"
    }
  }, [_vm._v("雷克萨斯")])])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-sm-3 control-label"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('span', {
    staticClass: "red pt5px"
  }, [_vm._v(_vm._s(_vm.alertMsg))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group text-right pt10px"
  }, [_c('button', {
    staticClass: "btn btn-primary modal-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.withdrawBtn
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary modal-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.nextClick
    }
  }, [_vm._v("下一步")])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-sm-1 text-right"
  }, [_c('span', {
    staticClass: "red dis_block  pt5px"
  }, [_vm._v("*")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51f33d59","transformToRequire":{"audio":"src"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/vehiclemonitor/instructions/InsGT520CaliVehicles.vue
// module id = 1513
// module chunks = 0